import React, { useCallback } from 'react';
import { useSafeFocusEffect } from '@sg/garnish';

import { useOnOnboardingModalShow } from '../../../../hooks';
import { useLoyaltyOffers } from '../../useLoyaltyOffers';
import { LoyaltyOffersModal } from '../LoyaltyOffersModal';

// ─────────────────────────────────────────────────────────────────────────────

export const LoyaltyOffersModalContainer = () => {
  const {
    filteredOffers,
    isShowingOffersModal,
    isOffersModalEnabled,
    hideOffersModal,
    showOffersModal,
  } = useLoyaltyOffers();

  // NOTE: Offers modal should be hidden when the loyalty onboarding in-app message is shown.
  const hideOffersOnOnboardingModalShow = useOnOnboardingModalShow({
    onModalShow: hideOffersModal,
  });

  // ─── Effects ─────────────────────────────────────────────────────────

  useSafeFocusEffect(showOffersModal);
  useSafeFocusEffect(useCallback(() => hideOffersModal, [hideOffersModal]));
  useSafeFocusEffect(hideOffersOnOnboardingModalShow);

  // ─────────────────────────────────────────────────────────────────────

  if (!isOffersModalEnabled) return null;

  return (
    <LoyaltyOffersModal
      offers={filteredOffers}
      visible={isShowingOffersModal}
      hideOffersModal={hideOffersModal}
    />
  );
};
